import { useStore } from "../../../hooks/use-store";
import { useCallback, useEffect, useState } from "react";
import { useRequest } from "ahooks";
import { PipelineData } from "./Pipeline";

let interval
export const InternalQueueItem = (model: {
    pipeline: PipelineData,
    status: string,
    update: (pipeline: PipelineData, status: 'pending' | 'completed' | 'ending' | 'failed') => void,
}) => {

    const {
        dataStore: { appStore },
    } = useStore();

    const [stopped, setStopped] = useState(false);
    const { runAsync } = useRequest(
        async (model: { jobId: string }) =>
            appStore.getPipelineById(model.jobId),
        {
            loadingDelay: 20,
            manual: true,
            onSuccess: (model) => { },
        }
    );

    const getActualStatus = useCallback(async () => {
        if ((model.status === 'pending' || model.status === 'ending') && !stopped) {
            // console.log('checking!!!', model.status)
            try {
                const res = await runAsync({ jobId: model.pipeline.jobId })
                console.log('res', res)
                console.log('model.status', model.status)
                console.log('model.status', res.data)
                if (res && (res.status === 'completed' || res.status === 'failed') && model.status === 'pending') {
                    model.update(res.data, res.status)
                    setStopped(true)
                }
            } catch (error) {
                console.log(error)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        async function recursiveStatusCheck() {
            await getActualStatus();
            interval = setTimeout(recursiveStatusCheck, 2000);
        }

        if (model.status === 'pending' || model.status === 'ending') {
            // recursive get interval 

            // Start the recursive status check
            recursiveStatusCheck();
            return () => clearTimeout(interval!);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getActualStatus])


    return null
}